import React from 'react';

import * as S from './styles';

const Slide5: React.FC = () => {
  return (
    <S.Container>
      {/* <S.Subtitle>Blusão, collab Felipe Fanaia com UMS-458, R$ 780.</S.Subtitle> */}
    </S.Container>
  );
};

export { Slide5 };
